export const contentInView = (
  target: Element,
  callback: IntersectionObserverCallback,
  options: IntersectionObserverInit = { threshold: 0.15 }
) => {
  const observer = new IntersectionObserver(callback, options)
  observer.observe(target)
  return observer
}
